// Components
import { TextMaskReveal } from '../ui/TextMaskReveal/TextMaskReveal';

export const WhyHireArchieText = () => {
  return (
    <section
      id="why-hire-archie"
      className="flex flex-col items-center gap-[var(--spacing-48)] px-[var(--spacing-24)] py-[var(--spacing-96)] w-full max-w-[1224px] max-lg:px-[var(--spacing-24)] max-lg:py-[var(--spacing-64)] max-md:px-[var(--spacing-16)] max-md:py-[var(--spacing-48)] max-md:gap-[var(--spacing-32)]"
    >
      <TextMaskReveal
        as="h2"
        variant="h1"
        className="text-blue-1000 text-center"
        duration={0.8}
      >
        Why Hire Archie?
      </TextMaskReveal>

      <div className="flex flex-col items-center gap-[30px] max-w-[720px] text-center max-md:gap-[var(--spacing-24)]">
        <TextMaskReveal
          as="p"
          variant="display"
          className="text-blue-1000"
          duration={0.8}
        >
          Your team is drowning in the manual stuff that binds all the systems automation.
        </TextMaskReveal>

        <TextMaskReveal
          as="p"
          variant="h1"
          className="text-blue-1000"
          duration={0.8}
        >
          The form filling, the uploading and downloading, the submissions, the regulatory checks.
        </TextMaskReveal>

        <TextMaskReveal
          as="p"
          variant="h1"
          className="text-blue-1000"
          staggerDelay={0.1}
          duration={0.8}
        >
          You don't need more task automation. You need someone to actually do the work that's been impossible to automate.
        </TextMaskReveal>

        <TextMaskReveal
          as="p"
          variant="h1"
          className="text-blue-1000"
          duration={0.8}
        >
          The traits you'd want in your best staff accountant, built into AI that actually delivers.
        </TextMaskReveal>
      </div>
    </section>
  );
};
